"use client";

import posthog from "posthog-js";
import { useEffect } from "react";
import { type EventName, type EventData } from "@repo/analytics";

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY as string;

export function AnalyticsScript() {
	useEffect(() => {
		if (!posthogKey) {
			return;
		}

		posthog.init(posthogKey, {
			// use eu.i.posthog.com for european users
			api_host: "https://us.i.posthog.com",
			person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
		});
	}, []);
	
	return <></>;
}

export function useAnalytics() {
	const trackEvent = (event: EventName, data?: EventData) => {
		if (!posthogKey) {
			return;
		}

		posthog.capture(event, data);
	};

	// Legacy method for custom events not in our typed system
	const trackCustomEvent = (event: string, data?: Record<string, unknown>) => {
		if (!posthogKey) {
			return;
		}

		posthog.capture(event, data);
	};

	return {
		trackEvent,
		trackCustomEvent,
	};
}
